import type { PanelComponentSpec } from '@src/types/LayoutConfig';
import { IconName, MixpanelEventSource, withMixpanelSource } from '@talos/kyoko';
import { DEFAULT_ASIDE_WIDTH, MIN_ASIDE_WIDTH } from '../tokens';
import { PANEL_COMPONENT_GROUPS } from './groups';
import { HistoricalPriceChartPanel } from './HistoricalPriceChartPanel';
import { MultilegOrderBookPanel } from './MultilegOrderBookPanel';
import { OrderBookPanel } from './singleSymbol/OrderBookPanel';
import { PriceLadderPanel } from './singleSymbol/PriceLadderPanel';
import { TradesHistoryPanel } from './singleSymbol/TradesHistoryPanel';
import { VolumeLadderPanel } from './singleSymbol/VolumeLadderPanel';

export const SYMBOL_PANEL_COMPONENTS: PanelComponentSpec[] = [
  {
    group: PANEL_COMPONENT_GROUPS['symbol'],
    section: 'trading',
    type: 'orderBook',
    label: 'Order Book',
    renderer: OrderBookPanel,
    icon: IconName.OrderBook,
    canBeAdded: true,
    initialWidth: DEFAULT_ASIDE_WIDTH,
    minWidth: MIN_ASIDE_WIDTH,
  },
  {
    group: PANEL_COMPONENT_GROUPS['symbol'],
    section: 'trading',
    type: 'historicalPriceChart',
    label: 'Historical Price Chart',
    renderer: withMixpanelSource(HistoricalPriceChartPanel, MixpanelEventSource.HistoricalPriceChart),
    icon: IconName.PresentationChartBar,
    canBeAdded: true,
  },
  {
    group: PANEL_COMPONENT_GROUPS['symbol'],
    section: 'trading',
    type: 'tradesHistory',
    label: 'Trades History',
    renderer: TradesHistoryPanel,
    icon: IconName.Trades,
    canBeAdded: true,
    initialWidth: DEFAULT_ASIDE_WIDTH,
    minWidth: MIN_ASIDE_WIDTH,
  },
  {
    group: PANEL_COMPONENT_GROUPS['symbol'],
    section: 'trading',
    type: 'volumeLadder',
    label: 'Volume ladder',
    renderer: withMixpanelSource(VolumeLadderPanel, MixpanelEventSource.VolumeLadder),
    icon: IconName.Filter,
    canBeAdded: true,
    initialWidth: 360,
    minWidth: 200,
  },
  {
    group: PANEL_COMPONENT_GROUPS['symbol'],
    section: 'trading',
    type: 'priceLadder',
    label: 'Price ladder',
    renderer: withMixpanelSource(PriceLadderPanel, MixpanelEventSource.PriceLadder),
    icon: IconName.SortCumulative,
    canBeAdded: true,
    initialWidth: 360,
    minWidth: 200,
  },
  {
    group: PANEL_COMPONENT_GROUPS['symbol'],
    section: 'trading',
    type: 'multilegOrderBook',
    label: 'Multileg Order Book',
    renderer: withMixpanelSource(MultilegOrderBookPanel, MixpanelEventSource.MultilegOrderBook),
    icon: IconName.Columns,
    canBeAdded: true,
  },
];
